export default __webpack_public_path__ + "src/images/sections/3191c66961669c9d2e4e495ba473e7b4-design.jpg";